import { Box, Chip } from "@mui/material";
import React, { useState } from "react";

function ChipSelect(props) {
  const [selected, setSelected] = useState(new Set(props.defaultOptions || []));

  function handleSelectionChanged(id) {
    // treat state as immutable
    // React only does a shallow comparison so we need a new Set
    const newSet = new Set(selected);
    if (newSet.has(id)) newSet.delete(id);
    else newSet.add(id);
    setSelected(newSet);

    props.onChange(Array.from(newSet));
  }

  return (
    <Box>
      {props.options.map((option) => (
        <Chip
          key={option}
          onClick={() => handleSelectionChanged(option)}
          variant="filled"
          color={selected.has(option) ? "primary" : "default"}
          label={option}
          disabled={props.disabled}
          sx={{
            margin: "0 0.5rem 0.5rem 0",
            "& .MuiChip-label": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textTransform: "uppercase",
              fontWeight: "600",
            },
          }}
        />
      ))}
    </Box>
  );
}

export default ChipSelect;
